import { lazy, Suspense, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Index from "./jsx";
import { adminloginApi } from "./services/AuthService";
import { jwtDecode } from "jwt-decode";


import "./css/style.css";
import "./css/responsive.css";
import Error404 from "./jsx/pages/Error404";
import BookingDetails from "./venueManager/BookingDetails";
import PrivateRoute from "./jsx/components/PrivateRoute/PrivateRoute";
import Cookies from "js-cookie";
// Lazy-loaded components
const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() =>
  new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  })
);

function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  };
}

function App() {
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const Usertoken = queryParams.get("token");
  const cookieToken = Cookies.get("access_token_admin");
  const category_type = queryParams.get("category_type");
  // ponytail: public site stores localStorage "type" via JSON.stringify, so it arrives
  // here quoted (e.g. `"user"`); strip quotes so the `=== "user"` checks below match.
  const rawUsertype = queryParams.get("type");
  const Usertype = rawUsertype ? rawUsertype.replace(/^"+|"+$/g, "") : rawUsertype;
  const isNaviateToDelete = queryParams.get("isDelete") === "true";
  const user_category_main = queryParams.get("user_category_main");
  const id = queryParams.get("id");
  const schemeSecretkey = queryParams.get("secret_key");
  const bookingkey = queryParams.get("booking_key") === "true";
  const ticketkey = queryParams.get("ticket_key") === "true";
  const refreshParam = queryParams.get("refresh");

  // Set token synchronously so PrivateRoute finds it on first render.
  // Without this, PrivateRoute runs before the useEffect, sees empty localStorage,
  // and redirects to /admin-login — stripping the query params so the token is lost.
  if (cookieToken && Usertype === "user") {
    localStorage.setItem("access_token_admin", cookieToken);
    localStorage.setItem("user_type", Usertype);
    localStorage.setItem("user_category_main", user_category_main);
    localStorage.setItem("id", id);
    localStorage.setItem("isNaviateToDelete", isNaviateToDelete);
    localStorage.setItem("category_type", category_type);
    try {
      const decoded = jwtDecode(cookieToken);
      localStorage.setItem("login_Details", JSON.stringify({
        role: decoded.role || "User",
        user_level: decoded.user_level,
        id: decoded.id,
        name: decoded.name || decoded.first_name,
        email: decoded.email,
      }));
    } catch (_) {
      localStorage.removeItem("login_Details");
    }
  } else if (Usertoken && Usertype) {
    localStorage.setItem("access_token_admin", Usertoken);
    localStorage.setItem("user_type", Usertype);
    localStorage.setItem("user_category_main", user_category_main);
    localStorage.setItem("id", id);
    if (refreshParam) {
      Cookies.set("refresh_token", refreshParam, {
        expires: 7,
        secure: true,
        sameSite: "Lax",
        domain: ".khelouk.in",
      });
    }
    try {
      const decoded = jwtDecode(Usertoken);
      localStorage.setItem("login_Details", JSON.stringify({
        role: decoded.role || "User",
        user_level: decoded.user_level,
        id: decoded.id,
        name: decoded.name || decoded.first_name,
        email: decoded.email,
      }));
    } catch (_) {
      localStorage.removeItem("login_Details");
    }
  }

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isTokenChecked, setIsTokenChecked] = useState(false);

  useEffect(() => {
    const formMatch = window.location.pathname.match(/^\/grant-scheme\/form\/(.+)$/);
    const descMatch = window.location.pathname.match(/^\/grant-scheme\/description\/(.+)$/);
    const isGrantSchemedescMatch = window.location.pathname.match(/^\/grant-scheme/);

    const token = localStorage.getItem("access_token_admin");

    // If not authenticated and it's a grant scheme route, redirect to UK login
    if (!token && (formMatch || descMatch || isGrantSchemedescMatch)) {
      const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
      const externalUrl = `${ukWebsiteUrl}/login_email`;
      window.location.href = externalUrl;
      return;
    }

    // If token and type are in query, set them
    if (cookieToken && Usertype === "user") {
      localStorage.setItem("access_token_admin", cookieToken);

      localStorage.setItem("user_type", Usertype);
      localStorage.setItem("user_category_main", user_category_main);
      localStorage.setItem("id", id);
      localStorage.setItem("isNaviateToDelete", isNaviateToDelete);
      localStorage.setItem("category_type", category_type);
      try {
        const decoded = jwtDecode(cookieToken);
        localStorage.setItem("login_Details", JSON.stringify({
          role: decoded.role || "User",
          user_level: decoded.user_level,
          id: decoded.id,
          name: decoded.name || decoded.first_name,
          email: decoded.email,
        }));
      } catch (_) {
        localStorage.removeItem("login_Details");
      }

      setIsAuthenticated(true);
         const currentPath = window.location.pathname;
      if (bookingkey === true) {
        const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
        window.location.href = `${ukWebsiteUrl}/venue-slot-booking-details`;
      } else if (ticketkey === true) {
        const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
        window.location.href = `${ukWebsiteUrl}/ticket-booking-payment`;
      } else if (currentPath.includes("/user/delete-account")) {
        navigate("/user/delete-account");
      } else if (
        !schemeSecretkey ||
        schemeSecretkey === "null" ||
        bookingkey === false ||
        ticketkey === false
      ) {
        navigate("/profile");
      } else {
        navigate(`/grant-scheme/form/${schemeSecretkey}`);
      }
    } else if (Usertoken && Usertype) {
      localStorage.setItem("access_token_admin", Usertoken);
      localStorage.setItem("user_type", Usertype);
      localStorage.setItem("user_category_main", user_category_main);
      localStorage.setItem("id", id);
      try {
        const decoded = jwtDecode(Usertoken);
        localStorage.setItem("login_Details", JSON.stringify({
          role: decoded.role || "User",
          user_level: decoded.user_level,
          id: decoded.id,
          name: decoded.name || decoded.first_name,
          email: decoded.email,
        }));
      } catch (_) {
        localStorage.removeItem("login_Details");
      }

      setIsAuthenticated(true);
      navigate("/profile");
    } else {
      // Just set auth status from existing token
      setIsAuthenticated(!!token);
    }

    setIsTokenChecked(true);
  }, [Usertype, navigate]);

  // Store category_type from token; expiry is handled by PrivateRoute
  useEffect(() => {
    const token = localStorage.getItem("access_token_admin");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        localStorage.setItem("category_type", decoded.category_type);
      } catch (_) {
        // malformed token — PrivateRoute handles the redirect
      }
    }
  }, [navigate]);


  return (
    <Suspense fallback="Loading">
      <Routes>
        {/* Public routes */}
        {/* <Route path="/" element={<Login apifun={adminloginApi} />} /> */}
        {/* <Route
          path="/"
          element={
            Cookies.get("auth_token") ? (
              <NewDashboard/>
            ) : (
              <Login apifun={adminloginApi} />
            )
          }
        /> */}
        <Route
          path="/"
          element={
            (Cookies.get("access_token_admin") || localStorage.getItem("access_token_admin")) ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login apifun={adminloginApi} />
            )
          }
        />
        <Route path="/admin-login" element={<Login apifun={adminloginApi} />} />
        <Route path="/page-register" element={<SignUp />} />
        <Route path="/page-forgot-password" element={<ForgotPassword />} />
        {/* <Route path="/booking-details/:id" element={<BookingDetails />} /> */}

      {/* Private routes */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Index />
          </PrivateRoute>
        }
      />

      {/* 404 fallback */}
       <Route path="*" element={<Error404 />} />
    </Routes>
  </Suspense>
   );
}

export default withRouter(App);
